import { ConnectionWX, Headers, Request, RequestMethod, RequestOptions } from '@quan/http';
import { BaseClient } from '../../core';
import { isPrimitive } from '../../utils';
import { IExportData, ILog } from '../../core/types/log';
import { exceptionHandler, messageHandler } from './exceptionHandler';

export class WXClient extends BaseClient {
  captureException(err: Error | string) {
    const exception = isPrimitive(err)
      ? messageHandler(err as string)
      : exceptionHandler(err as Error);
    this.capture(exception);
  }

  captureMessage(data: ILog) {
    this.capture(data);
  }

  _doUpload(url: string, data: IExportData[]) {
    const xhr = new ConnectionWX();

    return xhr.createConnection(
      new Request(
        this._options.processRequestOptions!({
          url,
          method: RequestMethod.Post,
          body: JSON.stringify(this._options.processRequestData!(data)),
          headers: new Headers({
            'content-type': 'application/json',
          }),
        } as RequestOptions),
      ),
    ).response;
  }
}
